export class AppConstantsClass {
	siteWidth = 1420;
	get siteWidthCss() {
		return `${this.siteWidth}px`;
	}
}

export const AppConstants: AppConstantsClass = new AppConstantsClass();
